import React, { useEffect, useState } from 'react';
import '../../styled/pages/dashboard.scss';
import { Header, SideMenu } from '../../components';
import { customStyles } from '../../Utils/utils';

const Settings = () => {
  return (
    <section
      className="layoutContainer"
      style={customStyles.layoutBackground}
    >
      <div className="layoutGrid">
        <div className="page page--fullBody">
          <Header />
          <div className="page__body">
            <div className="page__content">
              <div className="page__body__head">
                <h1 className="title title--h1 title--normal">coming soon!</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
